import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import "../pages/css/chatbox.css";

export default function ChatBox({
  astrologer,      // ✅ FULL OBJECT
  user_id,
  sender,
  token,
  onClose,
}) {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState(""); // ✅ FIXED

  const astrologer_id = astrologer.astrologer_id;

  // =========================
  // Fetch Messages
  // =========================
  useEffect(() => {
    if (!astrologer_id) return;

    fetchMessages(); // initial load

    const interval = setInterval(() => {
      fetchMessages();
    }, 5000); // ⬅️ 5 seconds (not 2)

    return () => clearInterval(interval);
  }, [astrologer_id]);

  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/chat/messages`, {
        params: { user_id, astrologer_id },
        headers: { Authorization: `Bearer ${token}` },
      });

      // ✅ ALWAYS allow chat to open
      if (res.data.success) {
        setMessages(res.data.messages || []);
      } else {
        setMessages([]); // ⬅️ NO HISTORY = EMPTY CHAT
      }
    } catch (err) {
      // ⬇️ even on error, allow empty chat
      setMessages([]);
    }
  };

  // =========================
  // Send Message
  // =========================
  const sendMessage = async () => {
    if (!text.trim()) return;

    try {
      await axios.post(
        `${API_BASE_URL}/chat/send`,
        { user_id, astrologer_id, sender, text },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setText("");
      fetchMessages(); // ✅ safer than trusting response
    } catch (err) {
      console.log("Send message error:", err);
    }
  };

  return (
    <div className="chat-container h-100 d-flex flex-column">
      {/* Header */}
      <div className="chat-header d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <img
            src={astrologer.profile_photo}
            className="chat-avatar"
            alt="profile"
          />
          <strong>
            {astrologer.astrologer_name}
          </strong>
        </div>

        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      {/* Messages */}
      <div className="chat-body flex-grow-1 overflow-auto">
        {messages.length === 0 && (
          <p className="text-muted text-center mt-4">No messages yet</p>
        )}

        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`msg ${msg.sender === sender ? "me" : "other"}`}
          >
            <div className="bubble">{msg.text}</div>
            <small className="timestamp">{msg.timestamp}</small>
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="chat-input-wrapper">
        <input
          type="text"
          className="chat-input"
          placeholder="Type a message..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button className="send-btn" onClick={sendMessage}>➤</button>
      </div>
    </div>
  );
}
